export default __webpack_public_path__ + "static/media/Ecommerce_Home_-_World_Wide_Medias.bbfa76a4.png";